/*
 * @Author: qiyuanchen
 * @Date:   2019-04-16 10:11:11
 */
import { isInstalled } from './QBDownloadForShare';
import { isTBS, isAndroid } from './UA';
import { isLoadKuaiBao } from './PageConfigDataForShare';

// 点击写入剪切板
export function refreshRMP(docId) {
  console.log(`点击文章Id：${docId}`);
  // 快报拉新写入剪切板
  if (isLoadKuaiBao() && !isInstalled()) {
    const value = `σσqnreadingpaste://article_detail?nm=${docId}&function=qb_share&kd_channel_from=LIULANQI_SHARE_IMAGETEXT&refer=liulanqi_share_imagetextσσ`;
    window.ClipperForRMP && window.ClipperForRMP.createdClipboardForRefresh(value);
  } else {
    window.ClipperForRMP && window.ClipperForRMP.refreshRMP(docId);
  }
}
let rmpData = {};

// 初始化写入剪切板
export function initRMP(docIdArr) {
  return new Promise((resolve, reject) => {
    console.log(`初始化Id：${docIdArr}`);

    window.ClipperForRMP &&
      window.ClipperForRMP.initRMP({
        posid: '100271',
        event: 2,
        data: docIdArr,
        qbinstall: isAndroid(window.navigator.userAgent) && isTBS(window.navigator.userAgent) && isInstalled() ? 1 : 0,
        env: window.location.host.indexOf('.sparta.html5.qq.com') > -1 ? 'test' : 'pro', // 测试环境调用rmp的测试接口
      })
        .then((res) => {
          rmpData = Object.assign(rmpData, res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
  });
}

// 获取分享URL的docId
export function getShareURlDocId(url) {
  let docId = '';
  if (url) {
    const pathname = url.substring(0, url.indexOf('?'));
    const pathnameSplit = pathname.split('/');
    docId = pathnameSplit[pathnameSplit.length - 1];
  }
  return docId;
}

// 初始化剪切板
export function initClipboard(docId) {
  window.ClipperForRMP && window.ClipperForRMP.initClipboard(docId);
}

export function getDocIdRpmData(docId) {
  return rmpData[docId];
}
